import { useMemo } from 'react';
import { ColorTile } from "./components/ColorTile.js";
import { identicalColors } from "./functions/identicalColors.js";
import { useThemeColors } from "./hooks/useThemeColors.js";
import styles from "./ColorPalette.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ColorPalette({
  active,
  colors,
  onColorSelect
}) {
  const {
    themeColors,
    computeThemeColors
  } = useThemeColors();
  const computedColors = useMemo(() => {
    return colors.map(section => {
      if (typeof section === 'string' && section === 'THEME_COLORS') {
        return themeColors;
      }
      return section;
    });
  }, [colors, themeColors]);
  return /*#__PURE__*/_jsx("div", {
    className: styles.colorPicker,
    ref: computeThemeColors,
    children: computedColors.map(section => {
      return /*#__PURE__*/_jsx("div", {
        className: styles.section,
        children: section.map((color, index) => /*#__PURE__*/_jsx(ColorTile, {
          active: identicalColors(color, active),
          color: color,
          onColorSelect: onColorSelect
        }, color ?? index))
      }, section.join());
    })
  });
}